interface IconRoundedProps {
  icon: React.ReactNode;
  size?: number;
  isOverlay?: boolean;
}

const IconRounded: React.FC<IconRoundedProps> = ({ icon, size = 80, isOverlay }: IconRoundedProps) => {
  return (
    <div
      className='relative flex items-center justify-center shrink-0 rounded-full bg-border-primary overflow-hidden'
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      {icon}
      {isOverlay && <div className='absolute inset-0 rounded-full bg-border-primary/50' />}
    </div>
  );
};

export default IconRounded;
